/* eslint-disable no-secrets/no-secrets */
/* eslint-disable security/detect-object-injection */
import React, {
    useCallback,
    useContext
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import { PremierConstants } from 'premier-constant-service';
import { ToastProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import BuildingDesignSupplementalComponent from '../../components/ArchitectEngineer/BuildingDesignSupplemental/BuildingDesignSupplementalComponent';
import metadata from './ArchitectEngineerPage.metadata.json5';
import styles from './ArchitectEngineerPage.module.scss';
import messages from './ArchitectEngineerPage.messages';
import CoveragesPageComponent from "../Coverages/CoveragesPage";
import ProductCoverageSelection from "../../components/ArchitectEngineer/ProductCoverageSelection/ProductCoverageSelectionComponent"
import SubcontractorsWorkComponent from "../../components/ArchitectEngineer/SubcontractorsWork/SubcontractorsWorkComponent"
import CyberLiabilityInformationComponent from "../../components/ArchitectEngineer/CyberLiabilityInformation/CyberLiabilityInformationComponent"
import UnderwritingInformationComponent from '../../components/ArchitectEngineer/UnderwritingInformation/UnderwritingInformationComponent'
import ProjectsComponent from '../../components/ArchitectEngineer/Projects/ProjectsComponent'
import BusinessOperationComponent from '../../components/ArchitectEngineer/BusinessOperation/BusinessOperationComponent'
import RevenueComponent from '../../components/ArchitectEngineer/Revenue/RevenueComponent';
import OilGasSupplementalComponent from '../../components/ArchitectEngineer/OilGasSupplemental/OilGasSupplementalComponent';

function ArchitectEngineerPage(props) {

    const { wizardData: submissionVM, updateWizardData, changeNextSteps, steps } = props;
    // const viewModelService = useContext(ViewModelServiceContext);
    const { updateSubmission } = useUpdateSubmissionServices();
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'));
    const { lineName } = PremierConstants;
    const translator = useContext(TranslatorContext);

    const {
        onValidate,
        initialValidation
    } = useValidation('ArchitectEngineerPage');

    const validateBusOprBusSer = () => {
        const { businessServicesDTO } = submissionVM.lobData.value.proLine.coverables.arcEngProfessionalsCoverable.businessOperation;

        let isVisible = false;

        if (businessServicesDTO.length > 0) {
            let count = 0;

            businessServicesDTO.forEach(element => {
                if ((element.proSer1 === '7DesBuiEng' || element.proSer1 === '3BuiDes') && count === 0) {
                    isVisible = true;
                    // eslint-disable-next-line no-plusplus
                    count++;
                }
            });
        }

        return isVisible;
    }

    const onNext = useCallback(
        async () => {

            const totPerOfAllPro7 = _.get(submissionVM.value, 'lobData.proLine.coverables.arcEngProfessionalsCoverable.projects.typesofProjectsDTO[0].totPerOfAllPro7')
            
            if (totPerOfAllPro7 !== 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totPerErrorMsg),
                    autoClose: true
                });
                
                return false;
            }

            const {jobType} = submissionVM.value.baseData;

            if (!_.isUndefined(submissionVM.value.lobData.proLine.coverables.arcEngProfessionalsCoverable.productCoverageSelection.pro6)
                && submissionVM.value.lobData.proLine.coverables.arcEngProfessionalsCoverable.productCoverageSelection.pro6) {
                if (_.filter(steps, (step) => step.id.includes('property')).length === 0) {
                    if (jobType === 'PolicyChange') {
                        steps.splice(4, 0, propertySteps[0], propertySteps[1]);
                        changeNextSteps(steps.slice(3, 13))
                    } else {
                        steps.splice(5, 0, propertySteps[0], propertySteps[1]);
                        changeNextSteps(steps.slice(4, 13))
                    }
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (_.filter(steps, (step) => step.id.includes('property')).length !== 0) {
                    if (jobType === 'PolicyChange') {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(3, 12))
                    } else {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(4, 12))
                    }
                }
            }

            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'ArchitectEngineerPage', submissionVM);

            return submissionVM;
        },
        [changeNextSteps, lineName, propertySteps, steps, submissionVM, translator, updateSubmission]
    );

    const overrideProps = {
        productCoverageSelection: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.productCoverageSelection"
        },
        revenueComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.revenue"
        },
        businessOperationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.businessOperation"
        },
        projectsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.projects"
        },
        subcontractorsWorkComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.arcEngProfessionalsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo) && submissionVM.lobData.value.proLine.coverables.arcEngProfessionalsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo,
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.subcontractorsWork"
        },
        cyberLiabilityInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.cyberLiabilityInformation"
        },
        oilGasSupplementalComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.arcEngProfessionalsCoverable.businessOperation.worConToPetOrOilAnd60) && submissionVM.lobData.value.proLine.coverables.arcEngProfessionalsCoverable.businessOperation.worConToPetOrOilAnd60 > 0,
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.oilGasSupplemental"
        },
        buildingDesignSupplementalComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: validateBusOprBusSer(),
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.buildingDesignSupplemental"
        },
        underwritingInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.arcEngProfessionalsCoverable.underwritingInformation"
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelection: ProductCoverageSelection,
            revenueComponent: RevenueComponent,
            businessOperationComponent: BusinessOperationComponent,
            projectsComponent: ProjectsComponent,
            subcontractorsWorkComponent: SubcontractorsWorkComponent,
            cyberLiabilityInformationComponent: CyberLiabilityInformationComponent,
            oilGasSupplementalComponent: OilGasSupplementalComponent,
            underwritingInformationComponent: UnderwritingInformationComponent,
            buildingDesignSupplementalComponent: BuildingDesignSupplementalComponent,
            coveragespagecomponent: CoveragesPageComponent,
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.proLine.coverables.arcEngProfessionalsCoverable.aspects.subtreeValid

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.proLine.coverables.arcEngProfessionalsCoverable.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            
            await updateSubmission(lobLineName, 'ArchitectEngineerPage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

ArchitectEngineerPage.propTypes = wizardProps;
export default withRouter(ArchitectEngineerPage);
